import React, { useEffect, useState } from 'react';
import swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import ls from 'localstorage-slim';
import { getCurrencieLabel } from '../../../../constants/currencies';
import { SelectTickets } from '../../../OpenSell/Steps';
import { ticketTypes } from '../../../../helpers/ticketHelper.ts';
import {
  applyDiscounts,
  getTotalPaymentAmount,
} from '../../../../helpers/ticketPriceHelper.ts';
import { getCurrentLanguageTexts } from '../../../../constants/seasonPassPersonalInfoLangs.js';
import TermsAndConditionsModal from '../../TermsAndConditionsModal/TermsAndConditionsModal.js';
import { filterUnavailableTicketTemplates } from '../../../../helpers/filterUnavailableTicketTemplates.js';
import { FillCustomData } from './FillCustomData.jsx';
import { executePayment } from '../../../../helpers/paymentHelper/paymentHelper.ts';

const MySwal = withReactContent(swal);

export const BuyTicketsOnFutureEventModal = ({
  event,
  memberData,
  availiableSeatsCount,
  title,
  ...props
}) => {
  const [state, setState] = useState({
    tickets: [],

    isLoading: false,
  });
  const [isTermsChecked, setTermsChecked] = useState(false);
  const [chart, setChart] = useState(null);
  const [isShowTerms, setIsShowTerms] = useState(false);

  const txt = getCurrentLanguageTexts();

  const paymentMethod = event.allowedPaymentProviders.find(
    (p) => p.providerId === 0
  ); // kopa only

  applyDiscounts(state.tickets, event.ticketTemplates);
  const { total, administrativeFee, processingFee } = getTotalPaymentAmount(
    state.tickets,
    event,
    paymentMethod.fee
  );

  const createOrder = (fields = null) => {
    const redirectUrl = `${window.location.href}${
      window.location.href.includes('?') ? '&' : '?'
    }resultOrderId={Id}`;
    const paymentProviderId = event.allowedPaymentProviders[0].methodId;
    executePayment({
      eventData: event,
      paymentMethod: paymentProviderId,//35,//TODO: get id from event
      couponCode: '',
      redirectUrl: redirectUrl,
      ignoreCustomFields: true,
      tickets: state.tickets,
      paymentType: 1,
      transaction: {
        ...memberData,
        transactionFieldValues: !fields
          ? []
          : event.transactionFields
              .filter((f) => f.type === 0)
              .map((f) => ({
                value: fields[f.name] || '',
                transactionAddtitionalFieldId: f.id,
              })),
      },
    });
  };

  const confirmHandler = () => {
    setState((v) => {
      return {
        ...v,
        isLoading: true,
      };
    });

    const isCustomField = event.transactionFields.some((tf) => tf.type === 0);

    if (isCustomField) {
      MySwal.fire({
        html: (
          <FillCustomData
            event={event}
            createOrder={createOrder}
          />
        ),
        showConfirmButton: false,
        showCloseButton: true,
        customClass: 'public-user-modal member-page-modal',
        width: 500,
      });
    } else {
      createOrder();
    }
  };

  const onTicketAdded = (ticket) => {
    if (!ls.get('canAddTickets')) return;

    setState((state) => {
      if (ticket.type === ticketTypes.NO_SEAT) {
        const tickets = [...state.tickets, ticket];

        return {
          ...state,
          tickets,
        };
      }

      if (
        state.chart &&
        !ticket.masterTicket &&
        state.tickets.some((t) => t.label === ticket.label) &&
        ticket.type === ticketTypes.MAP
      ) {
        return {
          ...state,
        };
      }

      const tickets = [...state.tickets, ticket];

      return {
        ...state,
        tickets,
      };
    });
  };

  const onTicketRemoved = (ticket, manual = false) => {
    if (chart && ticket.type === ticketTypes.MAP) {
      chart.deselectObjects([ticket.label]);
    }

    if (chart && ticket.type === ticketTypes.MAP_NO_SEAT && manual) {
      chart.deselectObjects([{ label: ticket.label, amount: 1 }]);
      return;
    }

    setState((state) => {
      if (ticket.type === ticketTypes.NO_SEAT) {
        const index = state.tickets.findIndex(
          (i) => i.ticketTemplateId === ticket.ticketTemplateId
        );

        return {
          ...state,
          tickets: state.tickets.filter((item, i) => i !== index),
        };
      } else if (ticket.type === ticketTypes.MAP_NO_SEAT) {
        const index = state.tickets.findIndex((i) => i.label === ticket.label);
        return {
          tickets: state.tickets.filter((item, i) => i !== index),
        };
      } else if (ticket.type === ticketTypes.MAP) {
        return {
          tickets: state.tickets.filter((item) => item.id !== ticket.id),
        };
      }
    });
  };

  const handleTermsChangeCheckbox = (a) => {
    setTermsChecked(!isTermsChecked);
  };

  const showTermsAndConditionsModal = (ev) => {
    ev.preventDefault();
    setIsShowTerms(true);
    ls.set('canAddTickets', false);
  };

  const allowAddTicket = () => {
    window.setTimeout(() => ls.set('canAddTickets', true), 1000);
  };

  const closeTermsAndConditionsModal = () => {
    setIsShowTerms(false);
    allowAddTicket();
  };

  useEffect(() => {
    ls.set('canAddTickets', true);
  }, []);

  return (
    <section className='buy-ticket-modal'>
      {!isShowTerms ? (
        <>
          <h2 className='first-title'>{title}</h2>
          <div>
            <SelectTickets
              administrativeFee={administrativeFee}
              processingFee={processingFee}
              paymentMethodSelected={true}
              ticketTemplates={filterUnavailableTicketTemplates(
                event.ticketTemplates
              )}
              maxSelectedObjects={Math.min(
                availiableSeatsCount,
                event.maxSeatsToSelectPerTransaction
              )}
              pricing={filterUnavailableTicketTemplates(event.ticketTemplates).map(({ ticketTemplateId, categoryKey, price }) => ({
                      category: categoryKey,
                      ticketTemplateId,
                      price,
                  }))}
              tickets={state.tickets}
              onObjectSelected={onTicketAdded}
              onObjectDeselected={onTicketRemoved}
              hasSeats={
                event.ticketTemplates.length
                  ? event.ticketTemplates.filter((t) => t.hasSeats) >=
                    event.ticketTemplates.filter((t) => !t.hasSeats)
                  : undefined
              }
              workspaceKey={event.seatsIoWorkspaceId}
              eventSeatsId={event.seatsIoEventId}
              event={event}
              currency={getCurrencieLabel(event.currencyId)}
              total={total}
              popupMode={true}
              isTermsChecked={isTermsChecked}
              handleChangeCheckbox={handleTermsChangeCheckbox}
              showTermsAndConditionsModal={showTermsAndConditionsModal}
              onSetChart={(c) => setChart(c)}
            />
          </div>
        </>
      ) : (
        <TermsAndConditionsModal />
      )}
      <div className='swal2-actions'>
        {!isShowTerms ? (
          <>
            <button
              className='swal2-cancel swal2-styled'
              onClick={() => MySwal.close()}
            >
              {txt.generalTxt.cancel}
            </button>

            <button
              disabled={
                !state.tickets.length || state.isLoading || !isTermsChecked
              }
              className='swal2-confirm swal2-styled'
              onClick={confirmHandler}
            >
              {txt.generalTxt.buy}
            </button>
          </>
        ) : (
          <button
            type='button'
            className='swal2-cancel swal2-styled'
            onClick={closeTermsAndConditionsModal}
          >
            Ok
          </button>
        )}
      </div>
    </section>
  );
};
